import { render, staticRenderFns } from "./VEditButton.vue?vue&type=template&id=907da5de&scoped=true&"
import script from "./VEditButton.vue?vue&type=script&lang=js&"
export * from "./VEditButton.vue?vue&type=script&lang=js&"
import style0 from "./VEditButton.vue?vue&type=style&index=0&id=907da5de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907da5de",
  null
  
)

export default component.exports